import React,{useEffect} from 'react';
import CommonIn from '../utils/CommonIn';

const About = () => {

  useEffect(() => {
    // CommonIn과 ComponentUtil을 한 번만 호출하도록 수정
    CommonIn();    
  }, []); // Empty dependency array ensures this runs only once after initial render

  return (
    <>
      {/* 메인 컨텐츠 */}
      <main className="submain_about" id="submain">
        {/* 서브 헤더 */}
        <div className="sub_header">
          <div className="container sub_header_inner">
            <h1>회사 소개</h1>
          </div>
        </div>
        <div className="submenu">
          <div className="container">
            <div className="submenu_inner">
              <ul>
                <li><a href="#about_his">연혁 및 수상</a></li>
                <li><a href="#about_vis">비전 및 미션</a></li>
                <li><a href="#about_pat">고객사 및 파트너</a></li>
              </ul>
            </div>
          </div>
        </div>
        {/* 비주얼 섹션 */}
        <section className="about_visual">
          <div className="container about_visual_inner">
            <div className="visual_text">
              <h2>“기술로 연결된 신뢰의 세상”</h2>
              <p>
                FACEONE은 사람과 기술을 연결하여 신뢰를 구축하고, 더 안전하고 효율적인 세상을 만드는 데 기여하고자 합니다.<br/>단순히 기술 제공자가 아닌, 사용자 경험과 사회적 책임을 모두 고려하는 동반자가 되고자 합니다.
              </p>
            </div>
          </div>
        </section>
        {/* <!-- 주요 성과 --> */}
        
        <section className="about_history" id="about_his">
          <div className="container">
              <div className="tit"><h3>회사 연혁 및 주요 성과</h3></div>
              <div className="tit_info">발전과 성과로 쌓아온 신뢰의 시간</div>
              <div className="about_history_item-wrap">
                <div className="about_history_items">
                  <div className="about_history_img" data-aos="zoom-in"><img src="../assets/images/about_visual_img01.png" alt="메인 이미지"/></div>
                  <div className="about_history_item" >
                    <div className="tit"><h4>GS EPS 양자 내성 얼굴인식 출입 시스템 구축</h4></div>
                    <p>차세대 보안 기술인 양자 내성 암호를 적용한 얼굴인식 출입 시스템을 개발 및 구축하여, 안전성과 편의성을 동시에 강화하였습니다.</p>
                  </div>
                </div>
                <div className="about_history_items">
                  <div className="about_history_item" >
                    <div className="tit"><h4>LGU+ 양자내성 연구과제 수행<br/>( 얼굴인식 출입 시스템 )</h4></div>
                    <p>LGU+와 협력하여 양자 내성 암호 기반의 얼굴인식 출입 시스템 연구과제를 수행하며, 혁신적인 보안 기술 개발에 기여하였습니다.</p>
                  </div>
                  <div className="about_history_img" data-aos="zoom-in"><img src="../assets/images/about_visual_img02.png" alt="메인 이미지"/></div>
                </div>
                <div className="about_history_items">
                  <div className="about_history_img" data-aos="zoom-in"><img src="../assets/images/about_visual_img03.png" alt="메인 이미지"/></div>
                  <div className="about_history_item" >
                    <div className="tit"><h4>한림대 성심병원 얼굴인식 출입 관리 시스템 구축<br/>( 춘천/ 한강/ 강남 )</h4></div>
                    <p>한림대 성심병원의 춘천, 한강, 강남 캠퍼스에 얼굴인식 출입 관리 시스템을 구축하여 보안과 편의성을 강화하였습니다.</p>
                  </div>
                </div>
                <div className="about_history_items">
                  <div className="about_history_item" >
                    <div className="tit"><h4>물류터미널 내 모바일 얼굴인식 근태 서비스 확산</h4></div>
                    <p>대한통운, 롯데택배, 한진택배의 물류터미널에 모바일 얼굴인식 근태 서비스를 도입하여 운영 효율성과 근로자 편의성을 제고하였습니다.</p>
                  </div>
                  <div className="about_history_img" data-aos="zoom-in"><img src="../assets/images/about_visual_img04.png" alt="메인 이미지"/></div>
                </div>
                <div className="about_history_items">
                  <div className="about_history_img" data-aos="zoom-in"><img src="../assets/images/about_visual_img05.png" alt="메인 이미지"/></div>
                  <div className="about_history_item" >
                    <div className="tit"><h4>드림시큐리티 올리브네트웍스<br/>FGMS 개발 사업 수주/ 개발/ 인수</h4></div>
                    <p>드림시큐리티와 올리브네트웍스가 FGMS 개발 사업을 수주하고, 성공적으로 개발 및 인수를 완료하며 기술 역량을 강화하였습니다.</p>
                  </div>
                </div>
              </div>
          </div>
        </section>
        
        {/* <!-- 인증 및 수상 --> */}
        <section className="about_certi">
          <div className="container">
            <div className="tit"><h3>인증 및 수상</h3></div>
            <div className="tit_info">신뢰와 품질로 인정받은 발자취</div>
            <div className="about_certi_item-wrap">
              <div className="about_certi_items">
                <div className="about_certi_img" data-aos="zoom-in"><img src="../assets/images/about_certi_img01.png" alt="메인 이미지"/></div>
                <div className="about_certi_item" >
                  <div className="tit"><h4>AWS WAR( Well-Architected Reivew )이행</h4></div>
                  <p>AWS의 Well-Architected Review(WAR)를 이행하여<br/>클라우드 아키텍처의 안정성, 효율성, 보안성을 최적화하였습니다.</p>
                </div>
              </div>
              <div className="about_certi_items">
                <div className="about_certi_item">
                  <div className="tit"><h4>얼굴인식 양자내성 제품인증<br/>( NIPA )</h4></div>
                  <p>NIPA로부터 얼굴인식 양자내성 제품 인증을 획득하여 보안성과 신뢰성을 공식적으로 인정받았습니다.</p>
                </div>
                <div className="about_certi_img" data-aos="zoom-in"><img src="../assets/images/about_certi_img02.png" alt="메인 이미지"/></div>
              </div>
            </div>
          </div>
        </section>
  {/* <!-- //인증 및 수상 -->
  <!-- 팀 소개 --> */}
        <section className="about_team">
          <div className="container">
            <div className="tit_wrap">
              <div className="tit_info">우리는 인공지능 기술과 혁신적인 솔루션을 통해<br/>출입과 인증의 새로운 기준을 만듭니다.</div>
              <div className="tit"><h3>Dream T1</h3></div>
            </div>
            <div className="about_team_item_wrap">
              <div className="item" data-aos="fade-up">
                <div className="icon"><img src="../assets/images/about_team_icon01.png" alt="정확한 신분증 OCR 아이콘"/></div>
                <p className="team_tit">인사 총무팀</p>
                <p className="team_con">회사 운영의 핵심을 책임지는 전략가이자 지원자,<br/>모두가 일에 몰입할 수 있는 환경을 담당</p>
              </div>
              <div className="item" data-aos="fade-up">
                <div className="icon"><img src="../assets/images/about_team_icon02.png" alt="정확한 신분증 OCR 아이콘"/></div>
                <p className="team_tit">영업팀</p>
                <p className="team_con">고객의 니즈를 파악하고 최고의 솔루션을 제안하는<br/>비즈니스 전문가, 회사의 성장을 이끄는 최전선을 담당</p>
              </div>
              <div className="item" data-aos="fade-up">
                <div className="icon"><img src="../assets/images/about_team_icon03.png" alt="정확한 신분증 OCR 아이콘"/></div>
                <p className="team_tit">클라우드 서비스 팀</p>
                <p className="team_con">안정적이고 확장 가능한 클라우드 환경을 설계하는<br/>IT 전문가, 데이터를 효율적으로 다루는 기술의 선구자</p>
              </div>
              <div className="item" data-aos="fade-up">
                <div className="icon"><img src="../assets/images/about_team_icon04.png" alt="정확한 신분증 OCR 아이콘"/></div>
                <p className="team_tit">디바이스 컨버전스 팀</p>
                <p className="team_con">다양한 디바이스를 연결해 새로운 가능성을 창조하는<br/>융합 기술 전문가, 스마트한 세상을 구현</p>
              </div>
            </div>
          </div>
        </section>
  {/* <!--//팀 소개 -->
  <!-- 비전 --> */}
        <section className="about_vision" id="about_vis">
          <div className="container">
              <div className="tit" data-aos="fade-up">비전</div>
              <div className="tit_info" data-aos="fade-up">
                <h2>“인공지능과 혁신을 통해<br/>모든 출입과 인증을 더 안전하고 간편하게”</h2>
                <p className="tit_info_s">드림티원 얼굴인식 기반 인증 기술을 통해 미래형 신뢰 시스템을 구축하고, 개인과 조직의 일상적인 인증 과정을 혁신합니다.</p>
              </div>
              <div className="about_vision_item_wrap" data-aos="fade-up">
                <div className="circle-container">
                  <div className="center"><h3>Mission</h3></div>
                  <div className="item top-left">
                    <div className="vision_txt">
                      <h4 className="vision_tit">안전한 인증 환경 제공</h4>
                      <p className="vision_con">생체 인증 기술을 활용해 보안 수준을 강화하고,<br/>개인정보 유출 위험을 최소화합니다.</p>
                    </div>
                    <div className="icon orange"><img src="../assets/images/about_vision_icon01.png" alt="메인 이미지"/></div>
                  </div>
                  <div className="item top-right">
                    <div className="icon blue"><img src="../assets/images/about_vision_icon02.png" alt="메인 이미지"/></div>
                    <div className="vision_txt">
                      <p className="vision_tit">사용자 경험 혁신</p>
                      <p className="vision_con">직관적이고 간편한 솔루션을 제공하여,<br/>누구나 쉽게 사용할 수 있는 인증 서비스를 만듭니다.</p>
                    </div>
                  </div>
                  <div className="item bottom-left">
                    <div className="vision_txt">
                      <p className="vision_tit">다양한 산업에 확장성 제공</p>
                      <p className="vision_con">출입 통제, 근태 관리, 상업 인증 등 다양한 분야에<br/>유연하게 활용 가능한 솔루션을 제공합니다.</p>
                    </div>
                    <div className="icon purple"><img src="../assets/images/about_vision_icon03.png" alt="메인 이미지"/></div>
                  </div>
                  <div className="item bottom-right">
                    <div className="icon darkorange"><img src="../assets/images/about_vision_icon04.png" alt="메인 이미지"/></div>
                    <div className="vision_txt">
                      <p className="vision_tit">지속적인 기술 개발과 신뢰 구축</p>
                      <p className="vision_con">최신 트렌드에 맞춰 신뢰를 쌓고<br/>장기적 파트너십을 만듭니다.</p>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </section>
  {/* <!-- //비전 -->
  <!-- 핵심가치 --> */}
        <section className="about_core">
          <div className="tit" data-aos="fade-up"><h2>핵심가치</h2></div>
          <div className="container" data-aos="fade-up">
            <div className="about_core_item_wrap" >
              <div className="circle-container">
                <div className="item top-left">
                  <div className="icon orange"><img src="../assets/images/about_core_icon01.png" alt="메인 이미지"/></div>
                  <div className="core_txt">
                    <p className="core_tit">보안(Security)</p>
                    <p>데이터와 개인 정보를 철저히 보호</p>
                  </div>
                </div>
                <div className="item top-right">
                  <div className="icon orange"><img src="../assets/images/about_core_icon02.png" alt="메인 이미지"/></div>
                  <div className="core_txt">
                    <p className="core_tit">편의성(Convenience)</p>
                    <p>복잡한 과정을 단순화</p>
                  </div>
                </div>
                <div className="item bottom-left">
                  <div className="icon orange"><img src="../assets/images/about_core_icon03.png" alt="메인 이미지"/></div>
                  <div className="core_txt">
                    <p className="core_tit">정확성(Accuracy)</p>
                    <p>높은 인증 정확도로 사용자 신뢰 확보</p>
                  </div>
                </div>
                <div className="item bottom-right">
                  <div className="icon orange"><img src="../assets/images/about_core_icon04.png" alt="메인 이미지"/></div>
                  <div className="core_txt">
                    <p className="core_tit">혁신(Innovation)</p>
                    <p>항상 새로운 기술과 아이디어를 도입</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
  {/* <!-- //핵심가치 -->
   <!-- 가치관 --> */}
        <section className="about_values">
          <div className="tit" data-aos="fade-up"><h3>가치관</h3></div>
          <div className="container">
            <div className="values_box_wrap" data-aos="fade-up">
              <div className="values_box">
                <div className="icon"><img src="../assets/images/about_values_icon01.png" alt="메인 이미지"/></div>
                <h4>신뢰 (Trust)</h4>
                <p className="con">모든 서비스의 기반은 신뢰입니다. 기술을 통해 사람들의 삶을 더 안전하게 하고, 기업과 고객 간의 신뢰를 강화합니다.</p>
              </div>
              <div className="values_box">
                <div className="icon"><img src="../assets/images/about_values_icon02.png" alt="메인 이미지"/></div>
                <h4>책임 (Responsibility)</h4>
                <p className="con">기술이 가져올 수 있는 윤리적, 사회적 영향을 깊이 고려하며, 개인정보 보호와 사용자 권익을 최우선으로 생각합니다.</p>
              </div>
              <div className="values_box">
                <div className="icon"><img src="../assets/images/about_values_icon03.png" alt="메인 이미지"/></div>
                <h4>혁신 (Innovation)</h4>
                <p className="con">기존의 방식에 안주하지 않고, 항상 새로운 아이디어와 기술을 탐구하여 최고의 인증 솔루션을 제공합니다.</p>
              </div>
              <div className="values_box">
                <div className="icon"><img src="../assets/images/about_values_icon04.png" alt="메인 이미지"/></div>
                <h4>지속 가능성 (Sustainability)</h4>
                <p className="con">단기적인 이익보다 장기적인 가치를 추구하며, 사회와 환경에 긍정적인 영향을 미치는 기술 개발에 힘씁니다.</p>
              </div>
              <div className="values_box">
                <div className="icon"><img src="../assets/images/about_values_icon04.png" alt="메인 이미지"/></div>
                <h4>포용 (Inclusivity)</h4>
                <p className="con">누구나 사용할 수 있는 접근 가능한 기술을 설계하며, 다양한 사용자의 필요를 충족시키는 서비스를 제공합니다.</p>
              </div>
            </div>
          </div>
        </section>
  {/* <!-- //가치관 -->
  <!--행동원칙--> */}
        <section className="about_princ" data-aos="fade-up">
          <div className="container">
            <div className="tit_wrap">
              <div className="tit" data-aos="fade-up"><h3>FACEONE의 행동 원칙</h3></div>
            </div>
            <div className="about_princ_item_wrap">
              <div className="item">
                <p className="num">01</p>
                <p className="item_tit">고객 중심</p>
                <p className="item_con">모든 개발과 서비스는 사용자의 편의성과<br/>안전성을 최우선으로 설계합니다.</p>
              </div>
              <div className="item">
                <p className="num">02</p>
                <p className="item_tit">데이터 보호</p>
                <p className="item_con">데이터를 안전하게 처리하며,<br/>개인정보는 법적 기준 이상으로 보호합니다.</p>
              </div>
              <div className="item">
                <p className="num">03</p>
                <p className="item_tit">지속적인 학습</p>
                <p className="item_con">변화하는 시장과 기술 트렌드에 발맞추어<br/>서비스를 발전시킵니다.</p>
              </div>
            </div>
          </div>
        </section>
  {/* <!--//행동원칙-->
  <!--파트너 로고 섹션--> */}
        <section className="partners" id="about_pat" data-aos="fade-up">
          <div className="container">
            <div className="tit" data-aos="fade-up"><h3 data-aos="fade-up">고객사 및 파트너</h3></div>
            <div className="Partners_logosContainerWrapper" >
              <div className="Partners_logosContainer_anibox">
                  <div className="Partners_logosRow Partners_moveLeft_left" >
                      <img src="../assets/images/logo/logo01.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo02.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo03.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo04.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo05.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo06.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo07.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo08.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo09.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo10.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo11.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo12.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo13.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo14.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo01.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo02.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo03.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo04.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo05.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo06.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo07.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo08.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo09.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo10.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo11.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo12.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo13.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/logo14.png" alt="Logo 1"/>
                  </div>
                  <div className="Partners_logosRow02 Partners_moveRight_right" >
                      <img src="../assets/images/logo/pt_logo01.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/pt_logo02.png" alt="Logo 2"/>
                      <img src="../assets/images/logo/pt_logo03.png" alt="Logo 3"/>
                      <img src="../assets/images/logo/pt_logo04.png" alt="Logo 4"/>
                      <img src="../assets/images/logo/pt_logo01.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/pt_logo02.png" alt="Logo 2"/>
                      <img src="../assets/images/logo/pt_logo03.png" alt="Logo 3"/>
                      <img src="../assets/images/logo/pt_logo04.png" alt="Logo 4"/>
                      <img src="../assets/images/logo/pt_logo01.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/pt_logo02.png" alt="Logo 2"/>
                      <img src="../assets/images/logo/pt_logo03.png" alt="Logo 3"/>
                      <img src="../assets/images/logo/pt_logo04.png" alt="Logo 4"/>
                      <img src="../assets/images/logo/pt_logo01.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/pt_logo02.png" alt="Logo 2"/>
                      <img src="../assets/images/logo/pt_logo03.png" alt="Logo 3"/>
                      <img src="../assets/images/logo/pt_logo04.png" alt="Logo 4"/>
                       <img src="../assets/images/logo/pt_logo01.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/pt_logo02.png" alt="Logo 2"/>
                      <img src="../assets/images/logo/pt_logo03.png" alt="Logo 3"/>
                      <img src="../assets/images/logo/pt_logo04.png" alt="Logo 4"/>
                      <img src="../assets/images/logo/pt_logo01.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/pt_logo02.png" alt="Logo 2"/>
                      <img src="../assets/images/logo/pt_logo03.png" alt="Logo 3"/>
                      <img src="../assets/images/logo/pt_logo04.png" alt="Logo 4"/>
                      <img src="../assets/images/logo/pt_logo01.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/pt_logo02.png" alt="Logo 2"/>
                      <img src="../assets/images/logo/pt_logo03.png" alt="Logo 3"/>
                      <img src="../assets/images/logo/pt_logo04.png" alt="Logo 4"/>
                      <img src="../assets/images/logo/pt_logo01.png" alt="Logo 1"/>
                      <img src="../assets/images/logo/pt_logo02.png" alt="Logo 2"/>
                      <img src="../assets/images/logo/pt_logo03.png" alt="Logo 3"/>
                      <img src="../assets/images/logo/pt_logo04.png" alt="Logo 4"/>
                  </div>
              </div>
            </div>
          </div>
        </section>

        {/* 추가 섹션들 */}
        {/* 인증 및 수상, 팀 소개, 비전, 핵심가치, 가치관, 행동원칙, 파트너 로고 섹션 */}
      </main>
     
     
  
    </>
  );
};

export default About;